import { render, staticRenderFns } from "./ProductInstallation.vue?vue&type=template&id=23edfcac&"
import script from "./ProductInstallation.vue?vue&type=script&lang=js&"
export * from "./ProductInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports